export const RegularExpression = {
    Name: new RegExp(/^[-a-zA-Z ']{2,100}$/),
    Email: new RegExp(
        /^(?=.{1,64}@)(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@(?=.{1,255}$)((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    ),
    Password: new RegExp(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[@#!$%&_-]).{8,16}$/),
    PhoneNumber: new RegExp(/^[0-9+-]{10,12}$/),
    MobileNumber: new RegExp(/^\d{10,12}$/),
    ZipCode: new RegExp(/^\d{5}(-\d{4})?$/),
    NDCCode: new RegExp(/^\d{11}$/),
    URL: new RegExp(
        /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/,
    ),
};
